import React from "react";
import css from "./style.scss";
import { connect } from "react-redux";

class AdBox extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.pro !== this.props.pro) {
      return true;
    }
    return false;
  }

  render() {
    let style = { width: this.props.width, height: this.props.height };
    if (this.props.pro) {
      return null;
    }
    return (
      <div style={style} className={css.real}>
        <a
          className={css.metricalAd}
          target="_blank"
          href="https://metrical.xyz?ref=stori.social"
        >
          <div className={css.image}>
            <img src="https://metrical.xyz/homepage/details.2.light.jpg" />
          </div>
          <div className={css.text}>
            <small>Tired of Cookie Banners?</small>
            <h4>Metrical, A privacy-first web analytics tool for everyone.</h4>
            <p>
              Finally a web analytics tool that is easy to use, privacy oriented
              and where you don't have to have a marketing degree to know how to
              use it.
            </p>
            <button>Try it now</button>
          </div>
        </a>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pro: state.user.authenticated && state.user.userData.subscription.active,
  };
};

export default connect(mapStateToProps)(AdBox);



// WEBPACK FOOTER //
// ./src/components/adBox/index.js